import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import AssetsFormConfig from 'containers/assets/AssetsFormConfig';
import AssetsEditSectionSwitch from 'containers/assets/AssetsEditSectionSwitch';

import Assets from 'components/assets';

import { getAsset, resetAssetsForm } from 'containers/assets/actions';

import { getCompany, getSubcompany } from 'auth/selectors';
import { getAsset as getCurrentAsset, getIsFetching } from 'selectors/assets';

class AssetsEditContainer extends PureComponent {
  componentWillMount = () => {
    const {
      company,
      subcompany,
      match: {
        params: { aid },
      },
    } = this.props;
    this.props.getAsset(aid, company.id, subcompany.id);
  };

  componentWillUnmount = () => this.props.resetAssetsForm();

  render = () => {
    return (
      <AssetsFormConfig
        render={({
          accounts,
          catalogs,
          costCenters,
          depreciations,
          employees,
          isLoading,
          locations,
          projects,
          providers,
          subaccounts,
          sublocations,
          inpcs,
          asset_levels,
        }) => (
          <Assets.Edit.Wrapper
            asset={this.props.asset}
            company={this.props.company}
            subcompany={this.props.subcompany}
          >
            <AssetsEditSectionSwitch
              accounts={accounts}
              asset={this.props.asset}
              catalogs={catalogs}
              company={this.props.company}
              costCenters={costCenters}
              depreciations={depreciations}
              employees={employees}
              isLoading={isLoading}
              isFetching={this.props.isFetching}
              locations={locations}
              projects={projects}
              providers={providers}
              subaccounts={subaccounts}
              subcompany={this.props.subcompany}
              sublocations={sublocations}
              inpcs={inpcs}
              asset_levels={asset_levels}
            />
          </Assets.Edit.Wrapper>
        )}
      />
    );
  };
}

const mapStateToProps = (state) => ({
  asset: getCurrentAsset(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
  isFetching: getIsFetching(state),
});

const mapDispatchToProps = { getAsset, resetAssetsForm };

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AssetsEditContainer));



// WEBPACK FOOTER //
// src/containers/assets/AssetsEditContainer.js